var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoFacturas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 34.667,
    viewBox: "0 0 26 34.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23828",
    "data-name": "Grupo 23828",
    transform: "translate(-63 -407.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_26._Clipboard",
    "data-name": "26. Clipboard",
    transform: "translate(59 407.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15547",
    "data-name": "Trazado 15547",
    d: "M26.75,34.333H7.25A3.25,3.25,0,0,1,4,31.083V7.25A3.25,3.25,0,0,1,7.25,4H8.333a1.083,1.083,0,0,1,0,2.167H7.25A1.083,1.083,0,0,0,6.167,7.25V31.083A1.083,1.083,0,0,0,7.25,32.167h19.5a1.083,1.083,0,0,0,1.083-1.083V17A1.083,1.083,0,0,1,30,17V31.083a3.25,3.25,0,0,1-3.25,3.25Z",
    transform: "translate(0 0.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15548",
    "data-name": "Trazado 15548",
    d: "M27.667,13.75a1.083,1.083,0,0,1-1.083-1.083V7.25A1.083,1.083,0,0,0,25.5,6.167H20.083a1.083,1.083,0,0,1,0-2.167H25.5a3.25,3.25,0,0,1,3.25,3.25v5.417A1.083,1.083,0,0,1,27.667,13.75Z",
    transform: "translate(1.25 0.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15549",
    "data-name": "Trazado 15549",
    d: "M19.667,8.5h-6.5A2.167,2.167,0,0,1,11,6.333V4.167A2.167,2.167,0,0,1,13.167,2h6.5a2.167,2.167,0,0,1,2.167,2.167V6.333A2.167,2.167,0,0,1,19.667,8.5Zm-6.5-4.333V6.333h6.5V4.167Z",
    transform: "translate(0.583 0.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15550",
    "data-name": "Trazado 15550",
    d: "M16.083,4.333A1.083,1.083,0,0,1,15,3.25V1.083a1.083,1.083,0,0,1,2.167,0V3.25A1.083,1.083,0,0,1,16.083,4.333Z",
    transform: "translate(0.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15551",
    "data-name": "Trazado 15551",
    d: "M13.417,17.5H9.083A1.083,1.083,0,0,1,8,16.417V12.083A1.083,1.083,0,0,1,9.083,11h4.333A1.083,1.083,0,0,1,14.5,12.083v4.333A1.083,1.083,0,0,1,13.417,17.5Zm-3.25-2.167h2.167V13.167H10.167Z",
    transform: "translate(0.333 0.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15552",
    "data-name": "Trazado 15552",
    d: "M13.417,26.5H9.083A1.083,1.083,0,0,1,8,25.417V21.083A1.083,1.083,0,0,1,9.083,20h4.333A1.083,1.083,0,0,1,14.5,21.083v4.333A1.083,1.083,0,0,1,13.417,26.5Zm-3.25-2.167h2.167V22.167H10.167Z",
    transform: "translate(0.333 1.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15553",
    "data-name": "Trazado 15553",
    d: "M23.583,15.167h-6.5a1.083,1.083,0,1,1,0-2.167h6.5a1.083,1.083,0,1,1,0,2.167Z",
    transform: "translate(1 1.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15554",
    "data-name": "Trazado 15554",
    d: "M23.583,24.167h-6.5a1.083,1.083,0,1,1,0-2.167h6.5a1.083,1.083,0,1,1,0,2.167Z",
    transform: "translate(1 1.833)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFacturas);
export default __webpack_public_path__ + "static/media/icono-facturas.b9405a1f14b64c0006b7272bdcf97c21.svg";
export { ForwardRef as ReactComponent };